import vmClient from 'app/services/vmClient';
import {
  Entity,
  EntityStringId,
  IEntity,
  IEntityType,
} from 'app/types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface ITeacherApplicationVideo extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
    question: string;
    answerTry: number;
    url: string;
  };
}

export type TeacherApplicationVideo = Entity<ITeacherApplicationVideo>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherApplicationVideo: IEntityType<ITeacherApplicationVideo> = vmClient.defineClass({
  typeName: 'TeacherApplicationVideo',
  version: 1,
  persisted: true,

  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    question: {
      type: 'string',
      notNull: true,
    },
    answerTry: {
      type: 'number',
      notNull: true,
    },
    url: {
      type: 'string',
      notNull: true,
    },
  },
});
